import {client as http} from '../../http_client';

export default {
    state: {
        studyPlans: {
            pending_count: 0
        }
    },
    getters: {
        studyPlans: state => state.studyPlans
    },
    mutations: {
        SET_STUDY_PLANS_COUNT(state, count) {
            state.studyPlans.pending_count = count;
        }
    },
    actions: {
        getStudyPlansCount({commit}) {
            return new Promise((resolve, reject) => {
                http.get('/study-plans/count', {force: true}).then(response => {
                    commit('SET_STUDY_PLANS_COUNT', response.data.count || 0);
                    resolve(response.data);
                }).catch(err => {
                    console.error('Error getting study plans count:', err);
                    reject(err);
                });
            });
        }
    }
}
